"use strict";

var _toConsumableArray = require("/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var simple_evaluate_1 = __importDefault(require("simple-evaluate"));
var validateFBTField_1 = __importDefault(require("../validateFBTField"));
function validateFBTStep(_ref) {
  var stepFields = _ref.stepFields,
    formPayload = _ref.formPayload,
    context = _ref.context;
  var invalidFields = stepFields.reduce(function (acc, field) {
    var fieldConditional = (field === null || field === void 0 ? void 0 : field.conditional) || '';
    var isConditionalField = !!fieldConditional;
    var isConditionallyValid = isConditionalField ? (0, simple_evaluate_1.default)({
      step: formPayload
    }, fieldConditional) : true;
    var fieldHasValidators = !!(field === null || field === void 0 ? void 0 : field.validators);
    if (fieldHasValidators && isConditionallyValid) {
      var fieldValidation = (0, validateFBTField_1.default)({
        field: field,
        formPayload: formPayload,
        context: context
      });
      if (!fieldValidation.isValid) {
        var invalidResult = {
          slug: field.slug,
          validationResults: fieldValidation.invalidValidations || []
        };
        return [].concat(_toConsumableArray(acc), [invalidResult]);
      }
      return acc;
    } else {
      return acc;
    }
  }, []);
  var hasInvalidFields = !!invalidFields.length;
  return {
    isValid: !hasInvalidFields,
    invalidFields: invalidFields
  };
}
exports.default = validateFBTStep;